import api from "../../../store/AuthHeader";

const addFeedBack = (payload: any) => {
    return api.post("FeedBack", payload);
}

const sendSupportRequest = (payload: any) => {
    return api.post("FeedBack/Support", payload);
}

export default {
    addFeedBack,
    sendSupportRequest
};